import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { ArrowForwardIos } from '@mui/icons-material';
function PickingSummaryBreadCrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="container-fluid p-0 breadcrumb">
      {vPathName === '/PickingSummary' ? (
        <div>
          <span
            className="breadcrumb-not-active "
            //  style={{ fontSize: '1rem', textDecorationLine: 'underline' }}
          >
            Picking Summary{' '}
          </span>
        </div>
      ) : vPathName === '/PickingDetail' ? (
        <div className="d-flex">
          <Link
            to="/PickingSummary"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={'breadcrumb-active mr-2'}>
            Picking Summary
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: '1px' }} />
          <div>
            <span
              className="breadcrumb-not-active"
              //  style={{ fontSize: '0.85rem', textDecorationLine: 'underline' }}
            >
              Picking Detail{' '}
            </span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
export default PickingSummaryBreadCrumbs;
